import { useDocItems } from '@modules/docs/providers';
import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuProps,
  Typography,
} from '@mui/material';
import { forwardRef, useMemo } from 'react';
import { DocItem } from 'src/@types/docs';
import { useLocales } from 'src/locales';
import Iconify from '../../iconify';
import { ExplorerMenu } from '../shared/ExplorerMenu';
import { DocsExplorerItem } from './DocsExplorerItem';

type DocsExplorerProps = MenuProps & {
  selectDoc: (doc: DocItem) => void;
  isSelected: (doc: DocItem) => boolean;
};

export const DocsExplorer = forwardRef<any, DocsExplorerProps>(
  ({ selectDoc, isSelected, open, anchorEl, onClose }, ref) => {
    const { translate } = useLocales();
    const { docs, isDocsLoading } = useDocItems();

    const docsChildren = useMemo(() => {
      if (!docs?.length) return [];
      return docs
        .filter((item) => !item.parent && !item.noteRef)
        .sort((a, b) => (a.order < b.order ? -1 : a.order > b.order ? 1 : 0));
    }, [docs]);

    return (
      <ExplorerMenu ref={ref} open={open} anchorEl={anchorEl} onClose={onClose}>
        <Typography variant="caption" color="text.secondary">
          {translate('header.nav_vertical.board_tab.docs')}
        </Typography>
        <Box>
          {isDocsLoading ? (
            <MenuItem>
              <ListItemIcon>
                <Iconify icon="eos-icons:loading" />
              </ListItemIcon>
              <ListItemText>{translate('share.loading')}</ListItemText>
            </MenuItem>
          ) : (
            docsChildren?.map((item) => (
              <DocsExplorerItem
                key={item._id}
                doc={item}
                selectDoc={selectDoc}
                isSelected={isSelected}
                docs={docs}
              />
            ))
          )}
        </Box>
      </ExplorerMenu>
    );
  },
);
